import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { ExpenseService } from 'app/shared/services/expense.service';
import { PurchaseInvoiceService } from 'app/shared/services/purchase-invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import * as moment from 'moment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

 
  invoiceList = [];
  purchaseList = [];
  salesOrderList  = [];
  isDark: boolean = false;
  // current month  data

  currentMonthSales : number = 0.00;
  currentMonthPurchases : number = 0.00;
  currentMonthProfit: number = 0.00;
  currentMonthExpenses : number = 0.00;
 
  unpaidInvoices : number = 0.00;

  customerOutstanding : number = 0.00;
  supplierOutstanding : number = 0.00;
  guestCount : number = 0.00;
  openOrders: number = 0.00;
  processingOrders: number = 0.00;


// // Sales Chart
monthlySaleArray = [1000,2000,3000,2000,5000,2500];
monthlyProfitArray = [800,1500,2000,1100,3000,900];
monthArray =  ['Jan','Feb','Mar','Apr','May','Jun'];
lineChartOptions = {
  scaleShowVerticalLines : false,
  responsive : true,
};

lineChartLabels = this.monthArray;
lineChartType = 'line';
lineChartLgend = true;

lineChartData = [
  {data : this.monthlySaleArray,label :'Sales'}
];

 // Pie Chart
  monthNameExp = ["January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December"
                    ];
    month  = this.monthNameExp[new Date().getMonth()];
    pieChartOptions = {
      position : 'right'
    };
  
    pieChartLabels = ['Total Invoice','Unpaid','PartlyPaid','Paid',];
    pieChartData = [100,60,70,40,80];
    pieChartType = 'pie';
    pieChartColors = [
      {
        backgroundColor: ['#009999','#FF6666', '#00FFFF', '#66FF66',],
      },
    ];
    pieChartLgend :
      {
        position: "right",
        align: "start"
      }
    
   

  // Profit Chart
  profitChartOptions = {
    scaleShowVerticalLines : false,
    responsive : true,
  };
  
  profitChartLabels = this.monthArray;
  profitChartType = 'bar';
  profitChartLgend = true;

  profitChartData = [
    {data : this.monthlyProfitArray,label :'Profit'},
    {data : this.monthlySaleArray,label :'Sales'}
  ];

  // Doughnut Chart
  
  doughnutChartLabels = ['Monday','Tuesday','Wednesday','Thursday','Friday'];
  doughnutChartData = [45,20,50,30,60];
  doughnutChartType = 'doughnut';
  doughnutChartColor = [
    {
      backgroundColor: ['#20B2AA', '#00FA9A', '#00CED1','#4682B4','#0000FF'],
    },
  ];
  
   monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
 
  constructor(
            private invoiceService: InvoiceService,
            private purchaseInvoiceService: PurchaseInvoiceService,
            private expenseService: ExpenseService,
            private router : Router,           
            private themeService: NbThemeService,
          
            ) { }

  ngOnInit() {
   this.getSales();
   this.getPurchase();
   this.getAllExpBreakup()
 


      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });

    }


     getSales(){
      this.invoiceService.getAll()
       .subscribe(
          (data) => {
                    this.invoiceList = data;                   
                    this.getCurrentMonthData(this.invoiceList);  
                    this.getSalesAndProfitPerMonth(this.invoiceList);         
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }
      

    getPurchase(){
    this.purchaseInvoiceService.getAll()
     .subscribe(
        (data) => {
                  this.purchaseList= data;
                  this.getCurrentMonthPurchase(this.purchaseList);
     
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

     getAllExpBreakup(){
      this.expenseService.getAllExpBreakup()
       .subscribe(
          (data) => {
                      this.getCurrentMonthExpense(data);                            
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });          
       }




       
     getCurrentMonthPurchase(arrayList){
        var filteredList : any = [];
        var startDate =moment().startOf('month').format("YYYY-MM-DD");
        var endDate =moment().endOf("month").format("YYYY-MM-DD");

        this.supplierOutstanding = arrayList.map(data=>data.BalToPay).reduce((acc,value)=>acc + +value,0);

        if(startDate && endDate){

          filteredList = arrayList.filter(data => {
                var invDate = moment(data.GrnDate).format("YYYY-MM-DD");              
                return moment(invDate).isBetween(startDate, endDate,undefined,'[]');               
                });

         this.currentMonthPurchases=filteredList.map(total=>total.GrandTotal).reduce((acc,value)=>acc + +value,0);
        
      
         }        
        
      }

      getCurrentMonthExpense(arrayList){
        var filteredList : any = [];
        var startDate =moment().startOf('month').format("YYYY-MM-DD");
        var endDate =moment().endOf("month").format("YYYY-MM-DD");

        if(startDate && endDate){

          filteredList = arrayList.filter(data => {
                var invDate = moment(data.ExpDate).format("YYYY-MM-DD");              
                return moment(invDate).isBetween(startDate, endDate,undefined,'[]');               
                });

         this.currentMonthExpenses=filteredList.map(total=>total.Amount).reduce((acc,value)=>acc + +value,0);
        
      
         }        
        
      }

    getCurrentMonthData(invoiceList){
          var filteredList : any = [];
          this.pieChartData  =[];

          var totalInvoice = 0.00;
          var unpaidInvoice = 0.00;
          var partlyPaidInvoice = 0.00;
          var paidInvoice= 0.00;

          var startDate =moment().startOf('month').format("YYYY-MM-DD");
          var endDate =moment().endOf("month").format("YYYY-MM-DD");

          this.customerOutstanding = invoiceList.map(data=>data.BalToPay).reduce((acc,value)=>acc + +value,0);

        if(startDate && endDate){

          filteredList = invoiceList.filter(data => {
                var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
                return moment(expDate).isBetween(startDate, endDate,undefined,'[]');               
                });

          this.currentMonthSales=filteredList.map(total=>total.GrandTotal).reduce((acc,value)=>acc + +value,0);
          this.currentMonthProfit = filteredList.map(total=>total.TotalProfit).reduce((acc,value)=>acc + +value,0);
         

          totalInvoice = filteredList.map(data=>data.GrandTotal).reduce((acc,value)=>acc + +value,0);
          unpaidInvoice = filteredList.filter(data => data.Status==='Unpaid').map(data=>data.BalToPay).reduce((acc,value)=>acc + +value,0);
          partlyPaidInvoice = filteredList.filter(data => data.Status==='Partly Paid').map(data=>data.BalToPay).reduce((acc,value)=>acc + +value,0);
          paidInvoice = filteredList.filter(data => data.Status==='Paid').map(data=>data.AmountPaid).reduce((acc,value)=>acc + +value,0);
          
          this.pieChartData.push(totalInvoice,unpaidInvoice,partlyPaidInvoice,paidInvoice);

          this.guestCount = filteredList.length ? filteredList.length: 0;

          }
             
    }


 

      getSalesAndProfitPerMonth(salesArray){

        var datedUpdated = new Date();
        var getDate;
        var getDateString;
        var getYearMonth;
        this.monthlySaleArray= [];
        this.monthlyProfitArray = [];
        this.monthArray = [];


        for (let x = 11; x >= 0; x--){   
          var monthlySales = 0;   
          var monthlyProfit = 0;
         getDateString =moment().subtract(x, 'months').format("YYYY-MM-DD");
         datedUpdated = new Date(getDateString);
   
          getYearMonth = moment(getDateString).format("YYYY-MM");
          this.monthArray.push(this.monthNames[datedUpdated.getMonth()]);
         
          for(let i= 0;i< salesArray.length;i++){
            var collDate = new Date(salesArray[i].InvoiceDate);
            getDate =moment(collDate).format("YYYY-MM");

            if(getYearMonth== getDate){
              monthlySales +=  +salesArray[i].GrandTotal;;
              monthlyProfit +=  +salesArray[i].TotalProfit;
            }
          }

          this.monthlySaleArray.push(monthlySales);
          this.monthlyProfitArray.push(monthlyProfit);
        }

        this.lineChartLabels  = this.monthArray;
        this.profitChartLabels = this.monthArray;

         this.lineChartData = [
           {data : this.monthlySaleArray,label :'Sales'}
         ];

         this.profitChartData = [
          {data : this.monthlyProfitArray,label :'Profit'},
          {data : this.monthlySaleArray,label :'Sales'}         
        ];
            
      }


      




    






}//end class
